function toggleTooltip(event, block) {
  const blockEl = document.getElementById(`${block}`);
  if (!blockEl) return;

  const parentFeature = blockEl.closest('[data-block-type="feature-with-icon"]');
  if (!parentFeature) return;

  // closing tooltip
  if (!event) {
    blockEl.classList.add('hide-tooltip');
    parentFeature.classList.remove('relative');
    return;
  }

  const trigger = event.currentTarget;
  if (!trigger) return;

  // opening tooltip
  if (blockEl.classList.contains('hide-tooltip')) {
    blockEl.classList.remove('hide-tooltip');
    parentFeature.classList.add('relative');

    const triggerRect = trigger.getBoundingClientRect();
    const parentRect = parentFeature.getBoundingClientRect();

    const left = triggerRect.left - parentRect.left - 40;
    blockEl.style.left = `${left}px`;
  } else {
    blockEl.classList.add('hide-tooltip');
    parentFeature.classList.remove('relative');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const htmlLang = (document.documentElement.lang || '').toLowerCase();
  const baseLang = htmlLang.split('-')[0];

  const langMap = {
    es: 'es',
    de: 'de',
    fr: 'fr',
    it: 'it',
    en: 'en-gb',
    'pt-pt': 'pt-pt',
    pt: 'pt-pt'
  };

  const zendeskLang = langMap[htmlLang] || langMap[baseLang] || 'es';

  const links = document.querySelectorAll(
    'a[href*="savefamilygpshelp.zendesk.com/hc/"]'
  );

  if (!links || links.length === 0) return;

  links.forEach((a) => {
    const href = a.getAttribute('href');
    if (!href) return;

    try {
      const url = new URL(href, window.location.origin);
      if (url.hostname !== 'savefamilygpshelp.zendesk.com') return;

      const parts = url.pathname.split('/');
      const hcIdx = parts.indexOf('hc');
      if (hcIdx === -1 || !parts[hcIdx + 1]) return;

      parts[hcIdx + 1] = zendeskLang;
      url.pathname = parts.join('/');

      a.href = url.toString(); 
    } catch (err) {
    }
  });
});


// popups logic

function getCallPopupById(popupId) {
  if (!popupId) return null;

  return (
    document.querySelector(`.call-us-popup[data-call-popup-id="${popupId}"]`) ||
    document.getElementById(popupId)
  );
}

function openCallPopup(popupId) {
  const popup = getCallPopupById(popupId);
  if (!popup) return;

  popup.hidden = false;
  document.documentElement.classList.add('call-popup-open');

  const dialog = popup.querySelector('.call-us-popup__dialog');
  if (dialog) {
    dialog.focus();
  }
}

function closeCallPopup(popupId) {
  const popup = getCallPopupById(popupId);
  if (!popup) return;

  popup.hidden = true;
  document.documentElement.classList.remove('call-popup-open');
}

function initCallPopups() {
  const popups = document.querySelectorAll('.call-us-popup');

  popups.forEach((popup) => {
    if (popup.dataset.callPopupInitialized === 'true') return;

    popup.dataset.callPopupInitialized = 'true';

    const popupId = popup.getAttribute('data-call-popup-id') || popup.id;

    popup.querySelectorAll('[data-call-popup-close]').forEach((el) => {
      el.addEventListener('click', () => closeCallPopup(popupId));
    });

    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCallPopup(popupId);
    });
  });
}

document.addEventListener('DOMContentLoaded', initCallPopups);
document.addEventListener('shopify:section:load', initCallPopups);

window.openCallPopup = openCallPopup;
window.closeCallPopup = closeCallPopup;